/**
 * Data Explorer -> Fabric communication.
 */
export var FabricMessageTypes;
(function (FabricMessageTypes) {
    FabricMessageTypes["GetAuthorizationToken"] = "GetAuthorizationToken";
    FabricMessageTypes["GetAllResourceTokens"] = "GetAllResourceTokens";
    FabricMessageTypes["GetAccessToken"] = "GetAccessToken";
    FabricMessageTypes["Ready"] = "Ready";
    FabricMessageTypes["OpenSettings"] = "OpenSettings";
    FabricMessageTypes["RestoreContainer"] = "RestoreContainer";
    FabricMessageTypes["ContainerUpdated"] = "ContainerUpdated";
})(FabricMessageTypes || (FabricMessageTypes = {}));
